import { memo } from 'react';

import { merge } from '@/components';
import { ComingSoon, MenuItem, MenuItemProps, Text } from '@/components/core';
import { FieldLogo } from '@/components/logos';
import { FieldState } from '@/store';
import { OmitChildren } from '@/utils';

export type NewFieldHelpProps = {
  namePlaceholder?: string;
  promptHintPlaceholder?: string;
  defaultName?: string;
};

export type FieldWithComingSoon = FieldState & {
  comingSoon?: boolean;
  helpProps?: NewFieldHelpProps;
};

export type TemplateModel = { fields: FieldWithComingSoon[]; sampleDocuments: string[] };

export type FieldMenuItemProps = OmitChildren<MenuItemProps> & {
  field: FieldWithComingSoon;
};

const IFieldMenuItem = ({ field, className, ...rest }: FieldMenuItemProps) => {
  return (
    <MenuItem
      className={merge('flex w-full items-center justify-start gap-2 rounded-lg border border-gray-200 p-2', className)}
      {...rest}
    >
      <FieldLogo field={field} size="xl" variant="formatter" />
      <div className="flex flex-1 flex-col">
        <Text size="sm" variant="secondary">
          {field.name}
        </Text>
        <Text size="xs">{field.promptHint}</Text>
      </div>
      {field.comingSoon ? <ComingSoon /> : null}
    </MenuItem>
  );
};

export const FieldMenuItem = memo(IFieldMenuItem) as typeof IFieldMenuItem;
